// Feature Flag Configuration
// This file defines all available feature flags and their metadata

export const FEATURE_FLAGS = {
  families_you_might_know: {
    key: 'families_you_might_know',
    name: 'Families You Might Know',
    description: 'Show suggested families based on shared programs',
    defaultEnabled: false,
    category: 'discovery'
  },
  quick_invite_options: {
    key: 'quick_invite_options',
    name: 'Quick Invite Options',
    description: 'Quick actions to invite families to programs',
    defaultEnabled: false,
    category: 'social'
  },
  enhanced_discovery: {
    key: 'enhanced_discovery',
    name: 'Enhanced Discovery',
    description: 'Enhanced program discovery experience',
    defaultEnabled: false,
    category: 'discovery'
  },
  show_pricing_page: {
    key: 'show_pricing_page',
    name: 'Show Pricing Page',
    description: 'Display pricing section on landing page',
    defaultEnabled: true,
    category: 'marketing'
  },
  premium_features: {
    key: 'premium_features',
    name: 'Premium Features',
    description: 'Enable premium-tier features',
    defaultEnabled: false,
    category: 'monetization'
  },
  beta_features: {
    key: 'beta_features',
    name: 'Beta Features',
    description: 'Enable beta-only features',
    defaultEnabled: false,
    category: 'beta'
  },
  admin_features: {
    key: 'admin_features',
    name: 'Admin Features',
    description: 'Enable admin dashboard features',
    defaultEnabled: false,
    category: 'admin'
  },
  blog_page: {
    key: 'blog_page',
    name: 'Blog Page',
    description: 'Enable blog page and navigation',
    defaultEnabled: false,
    category: 'content'
  }
};

// Build-time flag overrides from Vite environment variables
export const BUILD_TIME_FLAGS = {
  families_you_might_know: import.meta.env.VITE_FEATURE_FAMILIES_YOU_MIGHT_KNOW === 'true',
  quick_invite_options: import.meta.env.VITE_FEATURE_QUICK_INVITE_OPTIONS === 'true',
  enhanced_discovery: import.meta.env.VITE_FEATURE_ENHANCED_DISCOVERY === 'true',
  show_pricing_page: import.meta.env.VITE_FEATURE_SHOW_PRICING_PAGE !== 'false', // Default true
  premium_features: import.meta.env.VITE_FEATURE_PREMIUM_FEATURES === 'true',
  beta_features: import.meta.env.VITE_FEATURE_BETA_FEATURES === 'true',
  admin_features: import.meta.env.VITE_FEATURE_ADMIN_FEATURES === 'true',
  blog_page: import.meta.env.VITE_FEATURE_BLOG_PAGE !== 'false',
};

